import React from 'react';
import './CoverageMap.css';

const cities = [
  { name: 'Gaya', cx: 170, cy: 200 },
  { name: 'Muzaffarpur', cx: 175, cy: 100 },
  { name: 'Bhagalpur', cx: 310, cy: 155 },
  { name: 'Darbhanga', cx: 210, cy: 85 },
  { name: 'Purnia', cx: 320, cy: 90 },
  { name: 'Ara', cx: 130, cy: 170 },
  { name: 'Siwan', cx: 100, cy: 120 },
  { name: 'Chapra', cx: 130, cy: 120 },
  { name: 'Begusarai', cx: 250, cy: 130 },
  { name: 'Munger', cx: 280, cy: 145 },
  { name: 'Samastipur', cx: 225, cy: 115 },
  { name: 'Motihari', cx: 145, cy: 80 },
  { name: 'Sitamarhi', cx: 185, cy: 65 },
];

const patna = { name: 'Patna', cx: 185, cy: 155 };

const cityPills = ['Patna', 'Gaya', 'Muzaffarpur', 'Bhagalpur', 'Darbhanga', 'Purnia', 'Ara'];

const stats = [
  { value: '38', label: 'Districts' },
  { value: '24/7', label: 'Availability' },
  { value: '\u20B90', label: 'Hidden charges' },
  { value: '15m', label: 'Confirm time' },
];

const CoverageMap = () => {
  return (
    <section className="coverage">
      <div className="coverage__container">
        {/* Left — SVG Map */}
        <div className="coverage__map-col">
          <div className="coverage__map-wrapper">
            <svg
              className="coverage__svg"
              viewBox="0 0 420 300"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* State shape */}
              <ellipse
                cx="210" cy="145" rx="170" ry="115"
                fill="rgba(232,89,10,0.08)"
                stroke="rgba(232,89,10,0.25)"
                strokeWidth="1.5"
              />

              {/* Inner texture ellipse */}
              <ellipse
                cx="210" cy="145" rx="130" ry="85"
                fill="none"
                stroke="rgba(232,89,10,0.08)"
                strokeWidth="1"
                strokeDasharray="4 6"
              />

              {/* Grid lines — horizontal */}
              <line x1="60" y1="100" x2="360" y2="100" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />
              <line x1="60" y1="145" x2="360" y2="145" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />
              <line x1="60" y1="190" x2="360" y2="190" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />

              {/* Grid lines — vertical */}
              <line x1="140" y1="40" x2="140" y2="250" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />
              <line x1="210" y1="40" x2="210" y2="250" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />
              <line x1="280" y1="40" x2="280" y2="250" stroke="rgba(255,255,255,0.03)" strokeWidth="0.5" />

              {/* Connection lines from Patna */}
              {cities.map((city) => (
                <line
                  key={`line-${city.name}`}
                  className="coverage__line"
                  x1={patna.cx}
                  y1={patna.cy}
                  x2={city.cx}
                  y2={city.cy}
                />
              ))}

              {/* City dots */}
              {cities.map((city) => (
                <g key={city.name}>
                  <circle
                    className="coverage__pulse coverage__pulse--city"
                    cx={city.cx}
                    cy={city.cy}
                    r="4"
                  />
                  <circle
                    className="coverage__dot"
                    cx={city.cx}
                    cy={city.cy}
                    r="4"
                  />
                  <text
                    className="coverage__city-label"
                    x={city.cx}
                    y={city.cy - 9}
                    textAnchor="middle"
                  >
                    {city.name}
                  </text>
                </g>
              ))}

              {/* Patna hub — larger with pulse */}
              <circle
                className="coverage__pulse coverage__pulse--main"
                cx={patna.cx}
                cy={patna.cy}
                r="10"
              />
              <circle
                className="coverage__dot coverage__dot--main"
                cx={patna.cx}
                cy={patna.cy}
                r="8"
              />
              <text
                className="coverage__city-label coverage__city-label--main"
                x={patna.cx}
                y={patna.cy - 14}
                textAnchor="middle"
              >
                Patna
              </text>
            </svg>
          </div>

          {/* City pills */}
          <div className="coverage__pills">
            <span className="coverage__pill coverage__pill--hub">Patna (Hub)</span>
            {cityPills.slice(1).map((city) => (
              <span key={city} className="coverage__pill">{city}</span>
            ))}
            <span className="coverage__pill coverage__pill--more">+ 27 more</span>
          </div>
        </div>

        {/* Right — Content */}
        <div className="coverage__content-col">
          <span className="coverage__eyebrow">Pan-Bihar coverage</span>
          <h2 className="coverage__heading">Bihar ke har kone mein.</h2>
          <p className="coverage__body">
            From Siwan to Purnia, Sitamarhi to Gaya &mdash; ZilaCab covers every major route
            in Bihar. Our hub-and-spoke model means faster pickups, better prices, and
            drivers who know local roads.
          </p>

          <div className="coverage__stats">
            {stats.map((stat, i) => (
              <div key={i} className="coverage__stat">
                <span className="coverage__stat-value">{stat.value}</span>
                <span className="coverage__stat-label">{stat.label}</span>
              </div>
            ))}
          </div>

          <a href="#check-city" className="coverage__cta">
            Check your city &rarr;
          </a>
        </div>
      </div>
    </section>
  );
};

export default CoverageMap;
